import { apiUrl } from '../utils/constants';
import axios from 'axios';
import apiAxios from '../utils/apiAxios';

export const login = (email, password) => {
    return axios.post(`${apiUrl}auth/login`, { email, password })
}

export const login2FA = (temp_token, otp_code) => {
    return axios.post(`${apiUrl}auth/login/2fa`, { temp_token, otp_code })
}

export const getUserLogged = () => {
    return apiAxios.get(`auth/userLogged`)
}

export const logout = () => {
    return apiAxios.post(`auth/logout`)
}

export const getSessionConfig = () => {
    return apiAxios.get(`auth/session-config`)
}

export const updateSessionConfig = (timeout_minutes) => {
    return apiAxios.put(`auth/session-config`, { timeout_minutes })
}

export const keepaliveSession = () => {
    return apiAxios.post(`auth/session/keepalive`)
}

export const forgotPassword = (email) => {
    return axios.post(`${apiUrl}auth/forgot-password`, { email })
}

export const resetPassword = (token, password, confirmPassword) => {
    return axios.post(`${apiUrl}auth/reset-password`, { token, password, confirmPassword })
}

export const setup2FA = () => {
    return apiAxios.get(`auth/2fa/setup`)
}

export const enable2FA = (code) => {
    return apiAxios.post(`auth/2fa/enable`, { code })
}

export const disable2FA = (password) => {
    return apiAxios.post(`auth/2fa/disable`, { password })
}

export const get2FAStatus = () => {
    return apiAxios.get(`auth/2fa/status`)
}
